import { CircularProgress } from '@material-ui/core';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { handleLoginSuccess } from '../../helpers/loginHelper';
import { apiRequest } from '../../utils/api';

export const RedirectLogin = () => {
  const params = new URLSearchParams(window.location.search)
  const history = useHistory();

  useEffect(() => {
    const id = params.get('id');
    const otp = params.get('otp');

    if (!id || !otp) {
      history.push('/login');
      return;
    }

    const handleRedirect = async () => {
      try {
        const res = await apiRequest.post(`/api/autoLogin`, {
          id: id,
          otp: otp
        })

        const data = res.data

        handleLoginSuccess(data.user, history)
      } catch (err) {
        console.error(err)

        const message = err.response.data.msg || "Login failed"

        const encodedMessage = encodeURIComponent(message)

        history.push(`/?error=${encodedMessage}`)
      }

    }

    handleRedirect();
  }, [])

  return (
    <div className='d-flex justify-content-center align-items-center vh-100'><CircularProgress /></div>
  )
}
